import { Component, OnInit, inject } from '@angular/core';
import { ToasterService } from '../../../services/toaster.service';
import { CommonModule } from '@angular/common';
import { ToasterComponent } from '../toaster/toaster.component';
import { ToastOptions } from '../models';

@Component({
    selector: 'app-toaster-container',
    standalone: true,
    imports: [CommonModule, ToasterComponent],
    templateUrl: './toaster-container.component.html',
    styleUrl: './toaster-container.component.sass',
})
export class ToasterContainerComponent implements OnInit {
    private toaster = inject(ToasterService);

    toasts: ToastOptions[] = [];

    ngOnInit() {
        this.toaster.toast$.subscribe((toast) => {
            if (toast) {
                this.toasts = [toast, ...this.toasts];
                const timeout = toast.timer ?? 5000;

                setTimeout(() => {
                    this.toasts.pop();
                }, timeout);
            }
        });
    }

    toastDidRender(toastElement: HTMLElement, toast: ToastOptions) {
        if (toast.didOpen) {
            toast.didOpen(toastElement);
        }
    }

    remove(index: number) {
        this.toasts.splice(index, 1);
    }
}
